import { boardDetailsResource } from '@atlassian/jira-router-resources-classic-projects/src/services/board-details/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useBoardDetailsData = () => useResource(boardDetailsResource);
